var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vs-input',{ref:"inputDemand",staticClass:"w-full",on:{"keydown":function($event){return _vm.onKeyDown($event)}},model:{value:(_vm.demand),callback:function ($$v) {_vm.demand=$$v},expression:"demand"}})
}
var staticRenderFns = []

export { render, staticRenderFns }